// extracted by mini-css-extract-plugin
export default {"clientDetailsWrapper":"CustomerPortalCustomerDetails_clientDetailsWrapper__+znTW"};